<template>
  <div class="EditNew">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-card shadow="never">
        <el-row :gutter="20">
          <el-col :lg="17" :sm="17" :xs="24">
            <el-form-item prop="name" label="Nome" :error="error.name">
              <el-input size="large" v-model="ruleForm.name" required></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="ref_external_credit" label="Nome Referencia de Crédito">
                  <el-input size="large" v-model="ruleForm.ref_external_credit" required></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="ref_external_debit" label="Nome Referencia de Débito">
                  <el-input size="large" v-model="ruleForm.ref_external_debit" required></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="provider_id" label="Provedor" :error="error.provider_id">
              <SearchProviders :model="ruleForm.provider_id" :isEdit="isEdit" @handleValue="(x) => {$set(ruleForm, 'provider_id', x)}"/>
            </el-form-item>
          </el-col>
          <el-col :lg="7" :sm="7" :xs="24">
            <div v-loading="loadingUpImage">
              <label  class="el-form-item__label" style="width: 100%;text-align: left;">Logo</label>
              <el-upload
                ref="uploadImage"
                name="image"
                style="width: 100%; height: 200px;display: flex; align-items: center; justify-content: center;"
                class="avatar-uploader"
                :action="urlPostImage.url"
                :headers="urlPostImage.headers"
                :show-file-list="false"
                :auto-upload="autoUploadImage"
                :on-change="handleChange"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="urlImage" :src="urlImage" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="never" :body-style="{ padding: '0px' }" style="min-height: 100%;background-color: transparent; border: none; margin-top: 25px">
        <el-row :gutter="20">
          <el-col :lg="12" :sm="12" :xs="24">
            <el-card style="margin-top: 0; min-height: 100%;">
              <el-descriptions :title="'Taxas de planos antecipados'" />

              <el-row :gutter="20">
                <el-col :lg="18" :sm="18" :xs="24">
                  <el-form-item prop="rav" label="Rav" :error="error.rav">
                    <div class="space_imput">
                      <div class="el-input el-input--large">
                        <money class="el-input__inner" v-model="ruleForm.rav" v-bind="moneyRav"/>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :lg="6" :sm="6" :xs="24">
                  <el-button style="margin-top: 25px" @click.prevent="calcularRav()">Calcular</el-button>
                </el-col>
              </el-row>
              <div class="boxfees">
                <el-collapse accordion>
                  <el-collapse-item title="Débito" name="1">
                    <el-row :gutter="20">
                      <el-col :span="8">_
                      </el-col>
                      <el-col :span="8">
                        Taxa (%)
                      </el-col>
                      <el-col :span="8">
                        Taxa (R$)
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" v-for='(fee, index) in ruleForm.taxas.anticipation.debit' :key='index'>
                      <el-col :span="7">
                        Débito {{fee.number_installments}}x
                      </el-col>
                      <el-col :span="9">
                        <el-input type="number" v-model="fee.percent_amount">
                          <template slot="append">%</template>
                        </el-input>
                      </el-col>
                      <el-col :span="8">
                        <div class="space_imput">
                          <div class="el-input el-input--large">
                            <money class="el-input__inner" v-model="fee.amount" v-bind="money"/>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                  <el-collapse-item title="Crédito" name="2">
                    <el-row :gutter="20">
                      <el-col :span="8">_
                      </el-col>
                      <el-col :span="8">
                        Taxa (%)
                      </el-col>
                      <el-col :span="8">
                        Taxa (R$)
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" v-for='(fee, index) in ruleForm.taxas.anticipation.credit' :key='index'>
                      <el-col :span="7">
                        Crédito {{fee.number_installments}}x
                      </el-col>
                      <el-col :span="9">
                        <el-input type="number" v-model="fee.percent_amount">
                          <template slot="append">%</template>
                        </el-input>
                      </el-col>
                      <el-col :span="8">
                        <div class="space_imput">
                          <div class="el-input el-input--large">
                            <money class="el-input__inner" v-model="fee.amount" v-bind="money"/>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-card>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24">
            <el-card style="margin-top: 0; min-height: 100%;">
              <el-descriptions :title="'Taxas de planos não antecipados'" />
              <div class="boxfees">
                <el-collapse accordion>
                  <el-collapse-item title="Débito" name="1">
                    <el-row :gutter="20">
                      <el-col :span="8">_
                      </el-col>
                      <el-col :span="8">
                        Taxa (%)
                      </el-col>
                      <el-col :span="8">
                        Taxa (R$)
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" v-for='(fee, index) in ruleForm.taxas.naoAnticipation.debit' :key='index'>
                      <el-col :span="7">
                        Débito {{fee.number_installments}}x
                      </el-col>
                      <el-col :span="9">
                        <el-input type="number" v-model="fee.percent_amount">
                          <template slot="append">%</template>
                        </el-input>
                      </el-col>
                      <el-col :span="8">
                        <div class="space_imput">
                          <div class="el-input el-input--large">
                            <money class="el-input__inner" v-model="fee.amount" v-bind="money"/>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                  <el-collapse-item title="Crédito" name="2">
                    <el-row :gutter="20">
                      <el-col :span="8">_
                      </el-col>
                      <el-col :span="8">
                        Taxa (%)
                      </el-col>
                      <el-col :span="8">
                        Taxa (R$)
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" v-for='(fee, index) in ruleForm.taxas.naoAnticipation.credit' :key='index'>
                      <el-col :span="7">
                        Crédito {{fee.number_installments}}x
                      </el-col>
                      <el-col :span="9">
                        <el-input type="number" v-model="fee.percent_amount">
                          <template slot="append">%</template>
                        </el-input>
                      </el-col>
                      <el-col :span="8">
                        <div class="space_imput">
                          <div class="el-input el-input--large">
                            <money class="el-input__inner" v-model="fee.amount" v-bind="money"/>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import {clearRuleForm, makeErrorFilds} from "@/app/plugins/utils";
import {
  deleteCardBrand,
  getCardBrand,
  postCalcularRav,
  postCardBrand,
  putCardBrand
} from "@/app/domains/Config/services";
import HeaderPage from "@/app/components/HeaderPage";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import {mapGetters} from "vuex";
import {api as configs} from "@/app/config";

export default {
  name: "EditNewCardBrand",
  components: {
    HeaderPage,
    SearchProviders
  },
  data () {
    return {
      loadingPage: false,
      loadingUpImage: false,
      error: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      moneyRav: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 4,
        masked: false
      },
      ruleForm: {
        name: '',
        ref_external_credit: '',
        ref_external_debit: '',
        provider_id: '',
        taxas: {
          anticipation: {
            debit: [],
            credit: [],
          },
          naoAnticipation: {
            debit: [],
            credit: [],
          },
        }
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        provider_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
      urlImage: '',
      rawImage: null,
    }
  },
  computed: {
    isEdit: function () {
      return !!(this.ruleForm.id)
    },
    ...mapGetters('Auth', ['getToken']),
    autoUploadImage: function () {
      return (this.ruleForm.id) ? true : false
    },
    urlPostImage: function () {
      return {
        url: `${configs.baseUrl}import/logo/card_brand/${this.ruleForm.id}`,
        headers: {
          Authorization: 'Bearer ' + this.getToken
        }
      }
    }
  },
  methods: {
    async init () {
      if (this.$route.params.id !== undefined) {
        this.loadingPage = true
        try {
          let response = await getCardBrand(`/${this.$route.params.id}`)
          
          this.ruleForm = clearRuleForm(response.data)
          this.urlImage = response.data.image
          const debitn = []
          const creditn = []
          const debit = []
          const credit = []
          response.data.fees.map(fee => {
            if (fee.payment_type === 'debit' && fee.anticipation === 0) {
              debitn.push(fee)
            }
            if (fee.payment_type === 'debit' && fee.anticipation === 1) {
              debit.push(fee)
            }
            if (fee.payment_type === 'credit' && fee.anticipation === 0) {
              creditn.push(fee)
            }
            if (fee.payment_type === 'credit' && fee.anticipation === 1) {
              credit.push(fee)
            }
          })
          this.$set(this.ruleForm, 'taxas', { naoAnticipation: {credit: creditn, debit: debitn}, anticipation: {credit: credit, debit: debit} })
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
          await this.$router.push({name: 'config.cardbrand.index'})
        } finally {
          this.loadingPage = false
        }
      } else {
        const debitn = []
        const creditn = []
        const debit = []
        const credit = []
        for (let i = 1; i < 19; i++) {
          if (i === 1) {
            debitn.push({
              anticipation: 0,
              amount: 0,
              number_installments: i,
              payment_type: "debit",
              percent_amount: 0,
            })
            debit.push({
              anticipation: 1,
              amount: 0,
              number_installments: i,
              payment_type: "debit",
              percent_amount: 0,
            })
          }
          creditn.push({
            anticipation: 0,
            amount: 0,
            number_installments: i,
            payment_type: "credit",
            percent_amount: 0,
          })

          credit.push({
            anticipation: 1,
            amount: 0,
            number_installments: i,
            payment_type: "credit",
            percent_amount: 0,
          })
        }
        this.$set(this.ruleForm, 'taxas', { naoAnticipation: {credit: creditn, debit: debitn}, anticipation: {credit: credit, debit: debit} })
      }
    },
    TruncaValue(price, qtDecimal) {
      return parseFloat(Math.trunc(price * Math.pow(10, qtDecimal)) / Math.pow(10, qtDecimal)).toFixed(qtDecimal)
    },
    async calcularRav() {
      try {
        let response;
        response = await postCalcularRav({id: this.ruleForm.id, data: {rav: this.TruncaValue(this.ruleForm.rav, 4)}})
        await this.init()
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    handleChange(file) {
      
      this.loadingUpImage = true
      this.urlImage = URL.createObjectURL(file.raw);
      this.rawImage = file.raw
      // this.ruleForm.image = file.raw
      this.loadingUpImage = false
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.image = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isLt2M;
    },
    handleAction (ruleForm) {
      this.$confirm('Deseja excluir este Bandeira?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        this.error = {}
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          response = await deleteCardBrand('/' + this.ruleForm.id)
          await this.$router.push({name: 'config.cardbrand.index'})
          this.$message({
            showClose: true,
            message: 'Excluido',
            type: 'success'
          })
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
      });
    },
    submitForm (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.error = {}
          this.loadingPage = true
          try {
            let response;
            const fees = []
            this.ruleForm.taxas.naoAnticipation.credit.map(x => {
              fees.push(x)
            })
            this.ruleForm.taxas.naoAnticipation.debit.map(x => {
              fees.push(x)
            })
            this.ruleForm.taxas.anticipation.credit.map(x => {
              fees.push(x)
            })
            this.ruleForm.taxas.anticipation.debit.map(x => {
              fees.push(x)
            })
            this.$set(this.ruleForm, 'fees', fees)
            if (this.ruleForm.id !== undefined) {
              response = await putCardBrand(clearRuleForm(this.ruleForm))
              await this.$router.push({name: 'config.cardbrand.index'})
              this.$message({
                showClose: true,
                message: 'Editado com Sucesso',
                type: 'success'
              })
            } else {
              response = await postCardBrand(this.ruleForm)
              // if (this.rawImage !== null) {
              //   this.$refs['uploadImage'].submit()
              // }
              await this.$router.push({name: 'config.cardbrand.index'})
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
            }
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
  },
  async beforeMount() {
    await this.init()
  }
}
</script>

<style scoped>

</style>
